export class Customer {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}